<template>
  <div class="app">
    <div class="bg">
      <img class="bgImg" src="@/assets/bg.png" alt="" />
      <div class="codeBtn">
        <div class="box">
          <div class="code">邀请码： {{ invite_code }}</div>
          <div class="copy" @click="copy">复制</div>
        </div>

        <div>
          <img class="btnImg" src="@/assets/btn.png" alt="" @click="down" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "App",

  data() {
    return {
      invite_code: "",
    };
  },

  created() {
    const urlParams = window.location.href;
    console.log(urlParams);
    this.invite_code = urlParams.split("=")[1];
  },

  mounted() {
    this.detectDeviceType();
  },

  methods: {
    detectDeviceType() {
      const userAgent = navigator.userAgent.toLowerCase();

      // 判断安卓
      if (userAgent.indexOf("android") > -1) {
        this.deviceType = "Android";
      }

      // 判断iOS
      else if (
        userAgent.indexOf("iphone") > -1 ||
        userAgent.indexOf("ipad") > -1 ||
        userAgent.indexOf("ipod") > -1
      ) {
        this.deviceType = "iOS";
      }
      // 其他设备
      else {
        this.deviceType = "Unknown";
      }

      console.log("当前设备类型：", this.deviceType);
    },

    async copy() {
      try {
        // 通过 Clipboard API 复制文本
        await navigator.clipboard.writeText(this.invite_code);
        this.$message.success("邀请码复制成功");
      } catch (err) {
        this.$message.warning("复制失败");
      }
    },

    down() {
      if (this.deviceType == "Android") {
        window.location.href =
          "https://www.pgyer.com/Vyx68O?inviteCode=" + this.invite_code;
      } else if (this.deviceType == "iOS") {
        window.location.href =
          "itms-apps://apps.apple.com/cn/app/%E6%B7%98%E5%AE%B6%E5%B1%85/id6496279051?inviteCode=" +
          this.invite_code;
      }
    },
  },
};
</script>

<style>
* {
  margin: 0;
  padding: 0;
}

.app .bg {
  position: relative;
  width: 100vw;
  height: auto;
  background: #000;
}

.app .bg .bgImg {
  width: 100vw;
  height: auto;
  /* object-fit: contain; */
  vertical-align: middle;
}

.codeBtn {
  position: absolute;
  bottom: 190px;
  left: 0;
  right: 0;
  text-align: center;
  z-index: 9;
}

.codeBtn .box {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
}

.codeBtn .code {
  display: inline-block;
  color: #fff;
  border-radius: 20px;
  background: rgba(51, 51, 51, 0.6);
  padding: 6px 20px;
}

.codeBtn .copy {
  color: #fff;
  border-radius: 20px;
  background: rgba(51, 51, 51, 1);
  margin-left: 30px;
  padding: 6px 10px;
}

.app .bg .btnImg {
  width: 182px;
  height: 54px;
  margin: 20px auto;
}
</style>
